module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.13/_next/static/images/100mil-fundo-ouro-6dbea920af76a8f84cb0fe8c12110312.webp";